import React, { useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { TextField } from '@mui/material';
import { List } from 'react-window';

function RowComponent({ index, style, rows, getCellProps }) {
  const row = rows[index];
  const visibleCells = row.getVisibleCells();
  return (
    <div style={{ ...style, display: 'flex' }} className="tr">
      {visibleCells.map((cell, i) => {
        const isLast = i === visibleCells.length - 1;
        const cellProps = getCellProps ? getCellProps(cell) : {};
        return (
          <div
            className="td"
            key={cell.id}
            style={{
              width: cell.column.getSize(),
              ...(isLast ? { flex: 1 } : { flexShrink: 0 }),
              ...cellProps.style,
            }}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </div>
        );
      })}
    </div>
  );
}

const Table = ({ columns, data, hiddenColumns, getCellProps, updateLLViewSettings }) => {
  const columnVisibility = useMemo(() => {
    if (!hiddenColumns || hiddenColumns.length === 0) return {};
    return Object.fromEntries(hiddenColumns.map(col => [col, false]));
  }, [hiddenColumns]);

  const table = useReactTable({
    data: data || [],
    columns: columns || [],
    getCoreRowModel: getCoreRowModel(),
    state: { columnVisibility },
  });

  if (!columns || columns.length === 0 || !data) return null;

  const rows = table.getRowModel().rows;
  const listHeight = Math.round(window.innerHeight) - 250;

  return (
    <div className="table">
      <table>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id} className="tr" style={{ display: 'flex' }}>
              {headerGroup.headers.map((header, i, arr) => (
                <th key={header.id} className="th" style={{
                  width: header.getSize(),
                  ...(i === arr.length - 1 ? { flex: 1 } : { flexShrink: 0 }),
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    &nbsp;&nbsp;&nbsp;
                    <TextField
                      placeholder="Filter"
                      variant="outlined"
                      style={{ backgroundColor: 'white' }}
                      size="small"
                      InputLabelProps={{
                        style: {
                          height: 24,
                          top: '-6px',
                        },
                      }}
                      inputProps={{
                        style: {
                          height: 24,
                          padding: '0 0px',
                        },
                      }}
                      onChange={e => updateLLViewSettings('from_activity_search', e.target.value || null)}
                    />
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
      </table>
      <List
        rowComponent={RowComponent}
        rowCount={rows.length}
        rowHeight={35}
        rowProps={{ rows, getCellProps }}
        style={{ height: listHeight }}
      />
    </div>
  );
};

export default Table;
